import {ArrowBack} from "@mui/icons-material";
import {Button, Fab, IconButton} from "@mui/material";
import {useHistory} from "react-router-dom";


export interface APXWebAppBackButtonProps {
	  webAppRoutePath: string;
	  doExtraTasksOnClick?: () => void;
	  asFab?: boolean;
	  asIconButton?: boolean;
}


export default function APXWebAppBackButton({webAppRoutePath, doExtraTasksOnClick, asFab = false, asIconButton = false}: APXWebAppBackButtonProps) {
	  const history = useHistory();
	  if (asFab && asIconButton) throw new Error("asFab and asIconButton cannot be true at the same time");
	  if(/*FALSY->*/ !!!webAppRoutePath) throw new Error("webAppRoutePath cannot be empty");
	  return (
				 <>
						{
							  asFab ?
										 (
													<Fab size={"small"} onClick={() => {
														  history.replace(webAppRoutePath);
														  if (/*TRUTHY->*/!!doExtraTasksOnClick) doExtraTasksOnClick();
													}} color="primary"><ArrowBack/></Fab>
										 )
										 :
										 asIconButton ?
													(
															  <IconButton size={"large"} onClick={() => {
																	 history.replace(webAppRoutePath);
																	 if (/*TRUTHY->*/!!doExtraTasksOnClick) doExtraTasksOnClick();
															  }} color="primary"><ArrowBack/></IconButton>
													)
													:
													(
															  <Button size={"large"} startIcon={<ArrowBack/>} onClick={() => {
																	 history.replace(webAppRoutePath);
																	 if (/*TRUTHY->*/!!doExtraTasksOnClick) doExtraTasksOnClick();
															  }}>Back</Button>
													)
						}
				 </>
	  );
}